import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/double-11/2024/Index.vue')
const Rewards = () => import('../activity/double-11/2024/Rewards.vue')
const IndexSGE = () => import('../activity/double-11/2024-sge/Index.vue')
const RewardsSGE = () => import('../activity/double-11/2024-sge/Rewards.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/double-11/2024',
  name: 'activity_double_11_2024',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '双十一主会场',
  },
}

export const rewardsRoute: RouteConfig = {
  path: '/activity/double-11/2024/rewards',
  name: 'activity_double_11_2024_rewards',
  component: Rewards,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '我的奖品',
  },
}

export const indexSGERoute: RouteConfig = {
  path: '/activity/double-11/2024-sge',
  name: 'activity_double_11_2024_sge',
  component: IndexSGE,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '欢乐砸金蛋',
  },
}

export const rewardsSGERoute: RouteConfig = {
  path: '/activity/double-11/2024-sge/rewards',
  name: 'activity_double_11_2024_sge_rewards',
  component: RewardsSGE,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '我的奖品',
  },
}

export default [indexRoute, rewardsRoute, indexSGERoute, rewardsSGERoute]
